<div class="true-modal-container">
    <h1>Welcome to <br>Radiant MAG</h1>
    <ul>
        <li><div class="button" (click)="startNew()">Start new assessment</div></li>
        <li><div class="button" (click)="importDefault()">Import demo assessment</div></li>
        <li><div class="button" (click)="openExisting()">Open existing assessment</div></li>
        <!--<li><div class="button" (click)="manual()">Consult User Manual</div></li>-->
        <li><input type="checkbox" [(ngModel)]="notAgain" id="notAgain" /><label for="notAgain">Don't show again</label></li>
    </ul>
</div>
